import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

const SubscriptionPlanForm = ({
  initialData = null,   // If null → Add mode, else Edit mode
  onSubmit,             // function to send formData on submit
  loading = false       // to show spinner when submitting
}) => {

  // Default blank form (used for Add mode)
  const emptyForm = {
    plan_code: "",
    plan_name: "",
    plan_description: "",
    duration_days: "",
    price_paise: "",
    discount_percentage: "",
    trial: false,
    auto_renew: false,
    offer_text: "",
    gst_included: false,
    service: { id: "" }
  };

  const [formData, setFormData] = useState(emptyForm);

  // If initialData exists → Prefill for edit mode
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        ...initialData,
        service: { id: initialData?.service?.id || "" }
      });
    }
  }, [initialData]);

  // Common input handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Toggle switches handler
  const handleToggle = (key) => {
    setFormData((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Service dropdown
  const handleServiceChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      service: { id: Number(e.target.value) },
    }));
  };

  // Submit wrapper
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>

        {/* Plan Code */}
        <Col md={12}>
          <div className="mb-3">
            <label className="form-label fw-bold">Plan Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Plan Code"
              name="plan_code"
              value={formData.plan_code}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        {/* Plan Name */}
        <Col md={12}>
          <div className="mb-3">
            <label className="form-label fw-bold">Plan Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Plan Name"
              name="plan_name"
              value={formData.plan_name}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        {/* Description */}
        <Col md={12}>
          <div className="mb-3">
            <label className="form-label fw-bold">Description</label>
            <textarea
              className="form-control"
              placeholder="Enter Description"
              rows="3"
              name="plan_description"
              value={formData.plan_description}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        {/* Duration */}
        <Col md={6}>
          <div className="mb-3">
            <label className="form-label fw-bold">Duration (Days)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Duration"
              name="duration_days"
              value={formData.duration_days}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        {/* Price */}
        <Col md={6}>
          <div className="mb-3">
            <label className="form-label fw-bold">Price (₹ in Paise)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Price in Paise"
              name="price_paise"
              value={formData.price_paise}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        {/* Discount Percentage */}
        <Col md={6}>
          <div className="mb-3">
            <label className="form-label fw-bold">Discount (%)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Discount Percentage"
              name="discount_percentage"
              value={formData.discount_percentage}
              onChange={handleInputChange}
            />
          </div>
        </Col>

        {/* Offer Text */}
        <Col md={6}>
          <div className="mb-3">
            <label className="form-label fw-bold">Offer Text</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Offer Text"
              name="offer_text"
              value={formData.offer_text}
              onChange={handleInputChange}
            />
          </div>
        </Col>

        {/* GST Included */}
        <Col md={4}>
          <div className="mb-3">
            <label className="form-label fw-bold">GST Included</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={formData.gst_included}
                onChange={() => handleToggle("gst_included")}
              />
            </div>
          </div>
        </Col>

        {/* Trial */}
        <Col md={4}>
          <div className="mb-3">
            <label className="form-label fw-bold">Trial</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={formData.trial}
                onChange={() => handleToggle("trial")}
              />
            </div>
          </div>
        </Col>

        {/* Auto Renew */}
        <Col md={4}>
          <div className="mb-3">
            <label className="form-label fw-bold">Auto Renew</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={formData.auto_renew}
                onChange={() => handleToggle("auto_renew")}
              />
            </div>
          </div>
        </Col>

        {/* Service Dropdown */}
        <Col md={12}>
          <div className="mb-4">
            <label className="form-label fw-bold">Service</label>
            <select
              className="form-select"
              name="service"
              value={formData.service.id}
              onChange={handleServiceChange}
              required
            >
              <option value="">Select Service</option>
              <option value="1">Interior Design</option>
              <option value="2">Property Service</option>
              <option value="3">Other Service</option>
            </select>
          </div>
        </Col>
      </Row>

      {/* Buttons */}
      <Button variant="primary" type="submit" className="mt-4 mb-5">
        {loading ? "Saving..." : initialData ? "Update" : "Create"}
      </Button>
    </Form>
  );
};

export default SubscriptionPlanForm;
